/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Demand_Run_InvalidInputs */

const en_error_demand_run_invalid = /** @type {(inputs: Error_Demand_Run_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The season or the brand of the run does not exist.`)
};

/**
* | output |
* | --- |
* | "The season or the brand of the run does not exist." |
*
* @param {Error_Demand_Run_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_demand_run_invalid = /** @type {((inputs?: Error_Demand_Run_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Demand_Run_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_demand_run_invalid(inputs)
});